import { Select } from '@base-ui/react/select'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface SelectPositionerProps extends PartProps<Select.Positioner.Props> {
  className?: string
}

function SelectPositioner({ className, children, ...props }: SelectPositionerProps) {
  return (
    <Select.Positioner
      className={twMerge('-webkit-app-region-no-drag z-[100] outline-none', className)}
      // A dropdown: the list opens below the trigger, flush with its left edge, rather than over it.
      alignItemWithTrigger={false}
      align="start"
      sideOffset={4}
      {...props}
    >
      {children}
    </Select.Positioner>
  )
}

export { SelectPositioner }
export type { SelectPositionerProps }
